import { createRouter, createWebHistory } from 'vue-router'
import routes from  '@js/routes'

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {

        // Always scroll to top.
        return {
            behavior: 'smooth',
            top: 0
        }
    }
})

export default router
